export default {

  RECEIVE_STAGE: 'RECEIVE_STAGE',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',

  receiveStage(stage) {
    if (!stage) return;
    return { type: this.RECEIVE_STAGE, stage };
  },

  logout() {
    return { type: this.LOGOUT_SUCCESS };
  },
};
